



























import Vue from 'vue';
import DataSourceStatic from './dataSourceStatic.vue';
import PointConfig from './point/pointConfig.vue';
import DataSourceFilter from './dataSourceFilter.vue';
import DataSourceDisplay from './dataSourceDisplay.vue';
import AceEditor from './editor/ace.vue';
import { DataSource } from './types/interface';

export default Vue.extend({
    data() {
        return {
            staticDS: DataSource.Static,
            pointDS: DataSource.Point,

            scriptList: [{
                value: 'filter1',
                label: '脚本1'
            }, {
                value: 'filter2',
                label: '脚本2'
            }],
            scriptValue: '',

            showStaticData: '',
        }
    },
    props: {
        sourceType: Number,
        drawerVisble: Boolean,
    },
    computed: {
        sourceTypeLabel() {
            let label = '';
            console.log(typeof this.sourceType);
            
            switch(this.sourceType) {
                case this.staticDS:
                    label = '数据编辑器';
                    break;
                case this.pointDS:
                    label = '选择测点';
            }
            return label;
        }
    },
    components: {
        DataSourceStatic,
        PointConfig,
        DataSourceFilter,
        AceEditor,
        DataSourceDisplay
    },
    methods: {
    },
    mounted() {
        
    },
})
